import { render, staticRenderFns } from "./TheFormCategories.vue?vue&type=template&id=0eeafb25&scoped=true&"
import script from "./TheFormCategories.vue?vue&type=script&lang=ts&"
export * from "./TheFormCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eeafb25",
  null
  
)

export default component.exports